import Vue from 'vue';
import Cookies from 'js-cookie';
import VueRouter from 'vue-router';

import AuthLayout from '@/views/layout/auth';
import AdminLayout from '@/views/layout/admin';
import WorkshopLayout from '@/views/layout/workshop';

import AuthLoginPage from '@/views/pages/auth/login';
import AuthRegisterPage from '@/views/pages/auth/register';
import AuthRecoverPage from '@/views/pages/auth/recover';
import AuthResetPage from '@/views/pages/auth/reset';

import AdminHomePage from '@/views/pages/admin/home';
import AdminDashboardPage from '@/views/pages/admin/dashboard';
import AdminReportPage from '@/views/pages/admin/report';

import AdminUsersList from '@/views/pages/admin/users/list';
import AdminUsersNew from '@/views/pages/admin/users/new';
import AdminUsersEdit from '@/views/pages/admin/users/edit';

import AdminUserRolesList from '@/views/pages/admin/user-roles/list';
import AdminUserRolesNew from '@/views/pages/admin/user-roles/new';
import AdminUserRolesEdit from '@/views/pages/admin/user-roles/edit';

import AdminQuickReplyList from '@/views/pages/admin/quick-replies/list';
import AdminQuickReplyNew from '@/views/pages/admin/quick-replies/new';
import AdminQuickReplyEdit from '@/views/pages/admin/quick-replies/edit';

import AdminCustomPageList from '@/views/pages/admin/custom-pages/list';
import AdminCustomPageNew from '@/views/pages/admin/custom-pages/new';
import AdminCustomPageEdit from '@/views/pages/admin/custom-pages/edit';

import AdminFaqList from '@/views/pages/admin/faqs/list';
import AdminFaqNew from '@/views/pages/admin/faqs/new';
import AdminFaqEdit from '@/views/pages/admin/faqs/edit';

import AdminRepairList from '@/views/pages/admin/repair/list';
import AdminRepairHandle from '@/views/pages/admin/repair/handle';
import AdminRepairNew from '@/views/pages/admin/repair/new';
import AdminRepairNewManually from '@/views/pages/admin/repair/new-manually';

import AdminDevicesList from '@/views/pages/admin/devices/list';
import AdminDevicesNew from '@/views/pages/admin/devices/new';
import AdminDevicesEdit from '@/views/pages/admin/devices/edit';

import AdminDefectEdit from '@/views/pages/admin/defect/edit';
import AdminDefectList from '@/views/pages/admin/defect/list';
import AdminDefectNew from '@/views/pages/admin/defect/new';

import AdminRepairStatusList from '@/views/pages/admin/statuses/list';
import AdminRepairStatusEdit from '@/views/pages/admin/statuses/edit';
import AdminRepairStatusNew from '@/views/pages/admin/statuses/new';

import AdminRepairPriorityList from '@/views/pages/admin/priorities/list';
import AdminRepairPriorityEdit from '@/views/pages/admin/priorities/edit';
import AdminRepairPriorityNew from '@/views/pages/admin/priorities/new';

import AdminBrandList from '@/views/pages/admin/brands/list';
import AdminBrandNew from '@/views/pages/admin/brands/new';
import AdminBrandEdit from '@/views/pages/admin/brands/edit';

import AdminSettingsIndex from '@/views/pages/admin/settings';
import AdminSettingsGeneral from '@/views/pages/admin/settings/general';
import AdminSettingsSEO from '@/views/pages/admin/settings/seo';
import AdminSettingsAppearance from '@/views/pages/admin/settings/appearance';
import AdminSettingsLocalization from '@/views/pages/admin/settings/localization';
import AdminSettingsAuthentication from '@/views/pages/admin/settings/authentication';
import AdminSettingsOutgoingMail from '@/views/pages/admin/settings/outgoing-mail';
import AdminSettingsCaptcha from '@/views/pages/admin/settings/captcha';
import AdminSettingsCurrency from '@/views/pages/admin/settings/currency';
import AdminSettingsTax from '@/views/pages/admin/settings/tax';
import AdminSettingsGatways from '@/views/pages/admin/settings/gateways';
import AdminSettingsEmbeder from '@/views/pages/admin/settings/embeder';
import AdminSettingsSMS from '@/views/pages/admin/settings/sms';
import AdminSettingsTerms from '@/views/pages/admin/settings/terms';

import AdminBackupAndRestore from '@/views/pages/admin/backup/index';

import AdminLanguagesList from '@/views/pages/admin/language/list';
import AdminLanguagesNew from '@/views/pages/admin/language/new';
import AdminLanguagesEdit from '@/views/pages/admin/language/edit';

import AccountPage from '@/views/pages/account/account';

import RepairTrack from '@/views/pages/repair/repair-track';
import RepairBookingW1 from '@/views/pages/repair/book-w1';
import RepairBookingW2 from '@/views/pages/repair/book-w2';

import WorkshopWelcome from '@/views/pages/workshop/index';
import WorkshopRepairable from '@/views/pages/workshop/list';
import WorkshopRepairManage from '@/views/pages/workshop/manage';
import WorkshopRepairNew from '@/views/pages/workshop/new';
import WorkshopRepairNewManually from '@/views/pages/workshop/new-manually';
import WorkshopRepairTrack from '@/views/pages/workshop/track';

import PrintRepair from '@/views/pages/print/repair';
import PrintRepairDispatch from '@/views/pages/print/dispatch-info';

import DashboardNotFoundPage from '@/views/pages/admin/error/not-found';
import PageNotFoundPage from '@/views/pages/error/not-found';
import PageNotAccessPage from '@/views/pages/error/not-access';
import ContactUs from '@/components/elements/contact-us';

Vue.use(VueRouter);

const routes = [
  {
    path: '/repair-booking-embed',
    component: RepairBookingW1,
  },
  {
    path: '/repair-booking-embed-w2',
    component: RepairBookingW2,
  },
  {
    path: '/repair-contact-us-embed',
    component: ContactUs,
  },
  {
    path: '/repair-track-embed',
    component: RepairTrack,
  },
  {
    path: '/print/repair-order/:id',
    component: PrintRepair,
  },
  {
    path: '/print/repair-dispatch-info/:id',
    component: PrintRepairDispatch,
  },

  {
    path: '/auth',
    component: AuthLayout,
    redirect: '/auth/login',
    children: [
      {
        path: 'login',
        component: AuthLoginPage,
        meta: { middleware: 'guest' },
      },
      {
        path: 'register',
        component: AuthRegisterPage,
        meta: { middleware: ['guest', 'register'] },
      },
      {
        path: 'recover',
        component: AuthRecoverPage,
        meta: { middleware: 'guest' },
      },
      {
        path: 'reset/:token',
        component: AuthResetPage,
        meta: { middleware: 'guest' },
      },
    ],
  },
  {
    path: '/workshop',
    component: WorkshopLayout,
    redirect: '/workshop/welcome',
    meta: { middleware: 'auth', gate: null },
    children: [
      {
        path: '/account',
        component: AccountPage,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'welcome',
        component: WorkshopWelcome,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'repairable-list',
        component: WorkshopRepairable,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'repairable-list/:id/manage',
        component: WorkshopRepairManage,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'add-repair',
        component: WorkshopRepairNew,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'add-repair-manually',
        component: WorkshopRepairNewManually,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'track-repair/:key?',
        component: WorkshopRepairTrack,
        meta: { middleware: 'auth', gate: null },
      },
    ],
  },

  {
    path: '/admin',
    component: AdminLayout,
    redirect: 'admin/dashboard',
    meta: { middleware: 'auth', gate: null },
    children: [
      {
        path: 'home',
        component: AdminHomePage,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'dashboard',
        component: AdminDashboardPage,
        meta: { middleware: 'auth', gate: 'dashboard_access' },
      },
      {
        path: 'report',
        component: AdminReportPage,
        meta: { middleware: 'auth', gate: 'report_access' },
      },
      {
        path: 'repair-orders',
        component: AdminRepairList,
        meta: { middleware: 'auth', gate: 'repairs_manage' },
      },
      {
        path: 'repair-orders/:id/handle',
        component: AdminRepairHandle,
        meta: { middleware: 'auth', gate: 'repairs_manage' },
      },
      {
        path: 'repair-orders/new',
        component: AdminRepairNew,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'repair-orders/new-manually',
        component: AdminRepairNewManually,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'quick-replies',
        component: AdminQuickReplyList,
        meta: { middleware: 'auth', gate: 'manage_quick_replies' },
      },
      {
        path: 'quick-replies/new',
        component: AdminQuickReplyNew,
        meta: { middleware: 'auth', gate: 'manage_quick_replies' },
      },
      {
        path: 'quick-replies/:id/edit',
        component: AdminQuickReplyEdit,
        meta: { middleware: 'auth', gate: 'manage_quick_replies' },
      },
      {
        path: 'custom-pages',
        component: AdminCustomPageList,
        meta: { middleware: 'auth', gate: 'manage_custom_page' },
      },
      {
        path: 'custom-pages/new',
        component: AdminCustomPageNew,
        meta: { middleware: 'auth', gate: 'manage_custom_page' },
      },
      {
        path: 'custom-pages/:id/edit',
        component: AdminCustomPageEdit,
        meta: { middleware: 'auth', gate: 'manage_custom_page' },
      },
      {
        path: 'faq',
        component: AdminFaqList,
        meta: { middleware: 'auth', gate: 'manage_faq' },
      },
      {
        path: 'faq/new',
        component: AdminFaqNew,
        meta: { middleware: 'auth', gate: 'manage_faq' },
      },
      {
        path: 'faq/:id/edit',
        component: AdminFaqEdit,
        meta: { middleware: 'auth', gate: 'manage_faq' },
      },
      {
        path: 'repairable-devices',
        component: AdminDevicesList,
        meta: { middleware: 'auth', gate: 'manage_repair_devices' },
      },
      {
        path: 'repairable-devices/new',
        component: AdminDevicesNew,
        meta: { middleware: 'auth', gate: 'manage_repair_devices' },
      },
      {
        path: 'repairable-devices/:id/edit',
        component: AdminDevicesEdit,
        meta: { middleware: 'auth', gate: 'manage_repair_devices' },
      },

      {
        path: 'repairable-defects',
        component: AdminDefectList,
        meta: { middleware: 'auth', gate: 'manage_repair_defects' },
      },
      {
        path: 'repairable-defects/:id/edit',
        component: AdminDefectEdit,
        meta: { middleware: 'auth', gate: 'manage_repair_defects' },
      },
      {
        path: 'repairable-defects/new',
        component: AdminDefectNew,
        meta: { middleware: 'auth', gate: 'manage_repair_defects' },
      },
      {
        path: 'brands',
        component: AdminBrandList,
        meta: { middleware: 'auth', gate: 'manage_repairable_brands' },
      },
      {
        path: 'brands/new',
        component: AdminBrandNew,
        meta: { middleware: 'auth', gate: 'manage_repairable_brands' },
      },
      {
        path: 'brands/:id/edit',
        component: AdminBrandEdit,
        meta: { middleware: 'auth', gate: 'manage_repairable_brands' },
      },
      {
        path: 'repair-statuses',
        component: AdminRepairStatusList,
        meta: { middleware: 'auth', gate: 'manage_reply_statuses' },
      },
      {
        path: 'repair-statuses/new',
        component: AdminRepairStatusNew,
        meta: { middleware: 'auth', gate: 'manage_reply_statuses' },
      },
      {
        path: 'repair-statuses/:id/edit',
        component: AdminRepairStatusEdit,
        meta: { middleware: 'auth', gate: 'manage_reply_statuses' },
      },
      {
        path: 'repair-priorities',
        component: AdminRepairPriorityList,
        meta: { middleware: 'auth', gate: 'manage_repair_priorities' },
      },
      {
        path: 'repair-priorities/new',
        component: AdminRepairPriorityNew,
        meta: { middleware: 'auth', gate: 'manage_repair_priorities' },
      },
      {
        path: 'repair-priorities/:id/edit',
        component: AdminRepairPriorityEdit,
        meta: { middleware: 'auth', gate: 'manage_repair_priorities' },
      },
      {
        path: 'users',
        component: AdminUsersList,
        meta: { middleware: 'auth', gate: 'manage_users' },
      },
      {
        path: 'users/new',
        component: AdminUsersNew,
        meta: { middleware: 'auth', gate: 'manage_users' },
      },
      {
        path: 'users/:id/edit',
        component: AdminUsersEdit,
        meta: { middleware: 'auth', gate: 'manage_users' },
      },

      {
        path: 'user-roles',
        component: AdminUserRolesList,
        meta: { middleware: 'auth', gate: 'manage_user_roles' },
      },
      {
        path: 'user-roles/new',
        component: AdminUserRolesNew,
        meta: { middleware: 'auth', gate: 'manage_user_roles' },
      },
      {
        path: 'user-roles/:id/edit',
        component: AdminUserRolesEdit,
        meta: { middleware: 'auth', gate: 'manage_user_roles' },
      },
      {
        path: 'settings',
        component: AdminSettingsIndex,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'settings/general',
        component: AdminSettingsGeneral,
        meta: { middleware: 'auth', gate: 'general_configuration' },
      },
      {
        path: 'settings/seo',
        component: AdminSettingsSEO,
        meta: { middleware: 'auth', gate: 'seo_configuration' },
      },
      {
        path: 'settings/appearance',
        component: AdminSettingsAppearance,
        meta: { middleware: 'auth', gate: 'appearance_configuration' },
      },
      {
        path: 'settings/localization',
        component: AdminSettingsLocalization,
        meta: { middleware: 'auth', gate: 'localization_configuration' },
      },
      {
        path: 'settings/authentication',
        component: AdminSettingsAuthentication,
        meta: { middleware: 'auth', gate: 'authentication_configuration' },
      },
      {
        path: 'settings/outgoing-mail',
        component: AdminSettingsOutgoingMail,
        meta: { middleware: 'auth', gate: 'outgoing_mail_configuration' },
      },
      {
        path: 'settings/captcha',
        component: AdminSettingsCaptcha,
        meta: { middleware: 'auth', gate: 'captcha_configuration' },
      },
      {
        path: 'settings/currency',
        component: AdminSettingsCurrency,
        meta: { middleware: 'auth', gate: 'currency_configuration' },
      },
      {
        path: 'settings/tax',
        component: AdminSettingsTax,
        meta: { middleware: 'auth', gate: 'tax_configuration' },
      },
      {
        path: 'settings/payment-gateways',
        component: AdminSettingsGatways,
        meta: { middleware: 'auth', gate: 'gateways_configuration' },
      },
      {
        path: 'settings/embeder',
        component: AdminSettingsEmbeder,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'settings/sms',
        component: AdminSettingsSMS,
        meta: { middleware: 'auth', gate: 'sms_configuration' },
      },
      {
        path: 'settings/terms-conditions',
        component: AdminSettingsTerms,
        meta: { middleware: 'auth', gate: 'terms_condition' },
      },
      {
        path: 'backup',
        component: AdminBackupAndRestore,
        meta: { middleware: 'auth', gate: 'database_backup' },
      },
      {
        path: 'languages',
        component: AdminLanguagesList,
        meta: { middleware: 'auth', gate: 'manage_translations' },
      },
      {
        path: 'languages/new',
        component: AdminLanguagesNew,
        meta: { middleware: 'auth', gate: 'manage_translations' },
      },
      {
        path: 'languages/:id/edit',
        component: AdminLanguagesEdit,
        meta: { middleware: 'auth', gate: 'manage_translations' },
      },

      {
        path: '*',
        component: DashboardNotFoundPage,
        meta: { middleware: 'auth', gate: null },
      },
    ],
  },

  { path: '/', redirect: '/workshop/welcome' },
  { path: '/track/:key?', component: RepairTrack },
  { path: '/not-access', component: PageNotAccessPage },
  { path: '*', component: PageNotFoundPage },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeResolve((to, from, next) => {
  if (to.meta.middleware) {
    if (to.meta.middleware.includes('auth') && !localStorage.getItem('token')) {
      Cookies.set('intended_url', to.path);
      next('/auth/login');
    } else if (to.meta.middleware.includes('register') && !window.app.register) {
      next('/auth/login');
    } else if (localStorage.getItem('token') && to.meta.middleware.includes('guest')) {
      next();
    } else if (to.meta.middleware.includes('auth') && localStorage.getItem('token')) {
      axios.post(route('auth.check'), { gate: to.meta.gate }).then((response) => {
        if (!response.data.authorized) {
          Cookies.set('intended_url', to.path);
          next('/auth/login');
        } else if (!to.meta.gate) {
          next();
        } else {
          response.data.gate_pass ? next() : next('/admin/home');
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
